<template>
    <a-modal :title="state.modalTitle + `_限制规则`" :width="1000" :open="true" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button type="primary" :loading="state.submitLoading">确定</a-button>
            </a-popconfirm>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 10 }">
            <a-form ref="ruleForm" :model="formData" v-bind="formLayout">
                <a-form-item label="1. 限制平台" name="platform_id" required>
                    <PlatformPick v-model:value="formData.platform_id"></PlatformPick>
                </a-form-item>

                <a-form-item label="2. 限制主体类型">
                    <a-checkbox-group v-model:value="formData.main_type">
                        <a-row :gutter="[16, 16]">
                            <a-col :span="12">
                                <a-checkbox :value="1">公司</a-checkbox>
                            </a-col>
                            <a-col :span="12">
                                <a-checkbox :value="2">个体户</a-checkbox>
                            </a-col>
                            <a-col :span="12">
                                <a-checkbox :value="3">个人独资企业</a-checkbox>
                            </a-col>
                            <a-col :span="12">
                                <a-checkbox :value="4">合伙企业</a-checkbox>
                            </a-col>
                        </a-row>
                    </a-checkbox-group>
                    <div style="color: #999; font-size: 12px; margin-top: 4px;">不选择表示不限制主体类型</div>
                </a-form-item>

                <a-form-item label="3. 限制入驻税务身份">
                    <a-checkbox-group v-model:value="formData.is_ybr">
                        <a-row :gutter="[16, 16]">
                            <a-col :span="12">
                                <a-checkbox :value="1">一般纳税人</a-checkbox>
                            </a-col>
                            <a-col :span="12">
                                <a-checkbox :value="2">小规模纳税人</a-checkbox>
                            </a-col>
                        </a-row>
                    </a-checkbox-group>
                    <div style="color: #999; font-size: 12px; margin-top: 4px;">不选择表示不限制税务身份</div>
                </a-form-item>

                <a-form-item label="4. 限制入驻类型">
                    <a-checkbox-group v-model:value="formData.business_type">
                        <a-row :gutter="[16, 16]">
                            <a-col :span="8">
                                <a-checkbox :value="1">设立</a-checkbox>
                            </a-col>
                            <a-col :span="8">
                                <a-checkbox :value="2">同区迁入</a-checkbox>
                            </a-col>
                            <a-col :span="8">
                                <a-checkbox :value="3">跨区迁入</a-checkbox>
                            </a-col>
                        </a-row>
                    </a-checkbox-group>
                    <div style="color: #999; font-size: 12px; margin-top: 4px;">不选择表示不限制入驻类型</div>
                </a-form-item>

                <a-form-item label="5. 限制注册类型">
                    <a-checkbox-group v-model:value="formData.registration_type">
                        <a-row :gutter="[16, 16]">
                            <a-col :span="12">
                                <a-checkbox :value="1">包注册</a-checkbox>
                            </a-col>
                            <a-col :span="12">
                                <a-checkbox :value="2">裸地址</a-checkbox>
                            </a-col>
                        </a-row>
                    </a-checkbox-group>
                    <div style="color: #999; font-size: 12px; margin-top: 4px;">不选择表示不限制注册类型</div>
                </a-form-item>

                <a-form-item label="6. 是否添加警告">
                    <a-radio-group v-model:value="formData.is_warning">
                        <a-radio :value="1">是</a-radio>
                        <a-radio :value="2">否</a-radio>
                    </a-radio-group>
                    <div style="color: #999; font-size: 12px; margin-top: 4px;">开启警告后，用户操作时会收到警告提示</div>
                </a-form-item>

                <a-form-item label="7. 限制原因">
                    <a-textarea v-model:value="formData.reason" placeholder="请详细描述限制原因，如：违规操作、恶意刷单等" :rows="3"
                        show-count :maxlength="500" />
                </a-form-item>

                <a-form-item label="8. 限制时间">
                    <a-radio-group v-model:value="formData.is_permanent" @change="onPermanentChange"
                        style="margin-bottom: 12px;">
                        <a-radio :value="1">永久限制</a-radio>
                        <a-radio :value="2">指定时间</a-radio>
                    </a-radio-group>
                    <a-date-picker v-if="formData.is_permanent == 2" v-model:value="formData.expire_time" show-time
                        format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" placeholder="请选择限制结束时间"
                        style="width: 100%;" :disabled-date="disabledDate" />
                    <div style="color: #999; font-size: 12px; margin-top: 4px;">
                        {{ formData.is_permanent == 1 ? '限制将永久生效，如需解除请手动操作' : '限制将在指定时间后自动解除' }}
                    </div>
                </a-form-item>
            </a-form>
            <a-divider orientation="left">限制预览</a-divider>
            <div class="restrict-preview">
                <a-descriptions size="small" bordered :column="2">
                    <a-descriptions-item label="限制平台">
                        {{ getPlatformNamesStr(formData.platform_id) || '未限制' }}
                    </a-descriptions-item>
                    <a-descriptions-item label="限制主体类型">
                        {{ getSubjectTypeLabels(formData.main_type).join('、') || '未限制' }}
                    </a-descriptions-item>
                    <a-descriptions-item label="限制税务身份">
                        {{ getTaxIdentityLabels(formData.is_ybr).join('、') || '未限制' }}
                    </a-descriptions-item>
                    <a-descriptions-item label="限制入驻类型">
                        {{ getEntryTypeLabels(formData.business_type).join('、') || '未限制' }}
                    </a-descriptions-item>
                    <a-descriptions-item label="限制注册类型">
                        {{ getRegisterTypeLabels(formData.registration_type).join('、') || '未限制' }}
                    </a-descriptions-item>
                    <a-descriptions-item label="警告提示">
                        <a-tag :color="formData.is_warning == 1 ? 'orange' : 'green'">
                            {{ formData.is_warning == 1 ? '是' : '否' }}
                        </a-tag>
                    </a-descriptions-item>
                    <a-descriptions-item label="限制原因" :span="2">
                        {{ formData.reason || '未填写' }}
                    </a-descriptions-item>
                    <a-descriptions-item label="限制时间" :span="2">
                        {{ formData.is_permanent == 1 ? '永久' : (formData.expire_time ?
                            formData.expire_time : '未选择') }}
                    </a-descriptions-item>
                </a-descriptions>
            </div>
        </a-skeleton>
    </a-modal>
</template>

<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import dayjs, { Dayjs } from 'dayjs'
import { reactive, onMounted, ref } from 'vue'
import PlatformPick from '@/components/base/PlatformPick.vue'
import { getPlatformLabel, getPlatformLabels, getPlatformNamesStr } from '@/utils/dictUtils'

const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
    }
}
const ruleForm = ref()
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => { }
    },
    userInfo: {
        type: Object,
        default: () => { }
    }
})
interface IState {
    loading: boolean
    modalTitle: string
    submitLoading: boolean
}
const state = reactive<IState>({
    loading: false,
    modalTitle: '新增',
    submitLoading: false,
})
interface IformData {
    platform_id: number[]
    main_type: number[]
    is_ybr: number[]
    business_type: number[]
    registration_type: number[]
    is_warning: number
    reason: string
    is_permanent: number
    expire_time: string | null

}
const formData = reactive<IformData>({
    platform_id: [],
    main_type: [1, 2, 3, 4],
    is_ybr: [],
    business_type: [],
    registration_type: [],
    is_warning: 2,
    reason: '',
    is_permanent: 1,//1永久，2指定时间
    expire_time: null,
})
onMounted(() => {
    if (props.detailData?.id) {
        state.modalTitle = '编辑'
        queryDetail()
    }
})
const queryDetail = () => {
    state.loading = true
    let requeryParam = {
        url: `/admin/setRestrict/${props.detailData.id}/edit`,
        method: 'get'
    }
    baseService(requeryParam)
        .then((res) => {
            Object.assign(formData, res.data)
        })
        .finally(() => {
            state.loading = false
        })
}

const disabledDate = (current: Dayjs) => {
    return current && current < dayjs().startOf('day')
}

const onPermanentChange = () => {
    if (formData.is_permanent == 1) {
        formData.expire_time = null
    }
}
const subjectTypeMap: Record<number, string> = {
    1: '公司',
    2: '个体户',
    3: '个人独资企业',
    4: '合伙企业'
}

const taxIdentityMap: Record<number, string> = {
    1: '一般纳税人',
    2: '小规模纳税人'
}

const entryTypeMap: Record<number, string> = {
    1: '设立',
    2: '同区迁入',
    3: '跨区迁入'
}

const registerTypeMap: Record<number, string> = {
    1: '包注册',
    2: '裸地址'
}

const getSubjectTypeLabels = (keys: number[]) => (keys || []).map(k => subjectTypeMap[k] || k)
const getTaxIdentityLabels = (keys: number[]) => (keys || []).map(k => taxIdentityMap[k] || k)
const getEntryTypeLabels = (keys: number[]) => (keys || []).map(k => entryTypeMap[k] || k)
const getRegisterTypeLabels = (keys: number[]) => (keys || []).map(k => registerTypeMap[k] || k)

// 提交
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            // 设置限制 - 验证
            if (!formData.reason) {
                message.warning('请填写限制原因')
                return
            }

            if (formData.is_permanent == 2 && !formData.expire_time) {
                message.warning('请选择限制结束时间')
                return
            }

            const hasRestriction = formData.platform_id.length > 0 &&
                formData.main_type.length > 0 &&
                formData.is_ybr.length > 0 &&
                formData.business_type.length > 0 &&
                formData.registration_type.length > 0

            if (!hasRestriction) {
                message.warning('请选择每一个限制条件')
                return
            }

            state.loading = true
            if (props.detailData?.id > 0) {
                let requeryParam = {
                    url: '/admin/setRestrict/' + props.detailData.id + '/update',
                    method: 'put',
                    data: formData
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            } else {
                let requeryParam = {
                    url: '/admin/setRestrict/store',
                    method: 'post',
                    data: { ...formData, user_id: props.detailData.user_id }
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            }
        })
        .catch(() => { })
}
const cancel = () => {
    emit('cancel')
}
</script>

<style lang="less" scoped></style>
